const MedicalConditionCard = ({
  diagnosis = "Unknown",
  verification = "Unconfirmed",
  status = "Inactive",
  onsetDate = "",
  severity = "N/A",
  category = "",
  isDarkTheme = true,
}) => {
  // Responsive styles based on screen size
  const useResponsiveStyles = () => {
    // We could use useMediaQuery here like in the original code
    // For simplicity, we'll use a basic approach with CSS
    return {
      isMobile: window.innerWidth < 600,
    };
  };

  const { isMobile } = useResponsiveStyles();

  return (
    <div
      className="card-container"
      style={{
        backgroundColor: isDarkTheme ? "#433F81" : "#dfe0f7", // Light purple background for light mode
        borderRadius: "16px",
        padding: isMobile ? "1rem" : "1.5rem",
        color: isDarkTheme ? "white" : "#333",
        width: "100%",
        maxWidth: "1000px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        className="card-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
          flexWrap: isMobile ? "wrap" : "nowrap",
          gap: "0.5rem",
        }}
      >
        <h5
          style={{
            fontSize: isMobile ? "1rem" : "1.35rem", // Reduced from 1.5/1.75rem
            fontWeight: "500",
            margin: 0,
            color: isDarkTheme ? "white" : "#333",
          }}
        >
          {diagnosis}
        </h5>

        <div
          className="status-indicators"
          style={{
            display: "flex",
            gap: "0.75rem",
            flexWrap: "wrap",
          }}
        >
          <div
            className="status-badge active"
            style={{
              backgroundColor: isDarkTheme ? "#8D8ED5" : "#7879c7", // Slightly darker for light mode
              padding: "0.5rem 1.5rem",
              borderRadius: "2rem",
              fontSize: isMobile ? "0.8rem" : "0.875rem", // Reduced from 0.9/1rem
              fontWeight: "500",
              color: isDarkTheme ? "white" : "white",
            }}
          >
            {status}
          </div>

          <div
            className="priority-badge high"
            style={{
              backgroundColor: isDarkTheme ? "#E8756A" : "#df6a5f", // Slightly darker for light mode
              padding: "0.5rem 1.5rem",
              borderRadius: "2rem",
              fontSize: isMobile ? "0.8rem" : "0.875rem", // Reduced from 0.9/1rem
              fontWeight: "500",
              color: isDarkTheme ? "white" : "white",
            }}
          >
            {severity}
          </div>
        </div>
      </div>

      <div
        className="card-details"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem",
        }}
      >
        <div
          className="detail-row"
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "0.25rem" : "0.5rem",
          }}
        >
          <span
            className="detail-label"
            style={{
              color: isDarkTheme ? "#B8B8D9" : "#5D5FEF", // Darker for light mode
              fontSize: "0.875rem", // Reduced from 1rem
            }}
          >
            Category:
          </span>
          <span
            className="detail-value"
            style={{
              fontSize: "0.875rem", // Reduced from 1rem
              fontWeight: "500",
              color: isDarkTheme ? "white" : "#333",
            }}
          >
            {category}
          </span>
          <span
            className="separator"
            style={{
              margin: "0 0.5rem",
              display: isMobile ? "none" : "inline",
              color: isDarkTheme ? "white" : "#333",
            }}
          >
            |
          </span>
          <span
            className="detail-label"
            style={{
              color: isDarkTheme ? "#B8B8D9" : "#5D5FEF", // Darker for light mode
              fontSize: "0.875rem", // Reduced from 1rem
            }}
          >
            Verification Status:
          </span>
          <span
            className="detail-value"
            style={{
              fontSize: "0.875rem", // Reduced from 1rem
              fontWeight: "600",
              color: isDarkTheme ? "white" : "#333",
            }}
          >
            {verification}
          </span>
        </div>

        <div
          className="detail-row"
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "0.25rem" : "0.5rem",
          }}
        >
          <span
            className="detail-label"
            style={{
              color: isDarkTheme ? "#B8B8D9" : "#5D5FEF", // Darker for light mode
              fontSize: "0.875rem", // Reduced from 1rem
            }}
          >
            Onset Date:
          </span>
          <span
            className="detail-value"
            style={{
              fontSize: "0.875rem", // Reduced from 1rem
              fontWeight: "500",
              color: isDarkTheme ? "white" : "#333",
            }}
          >
            {onsetDate}
          </span>
          <span
            className="separator"
            style={{
              margin: "0 0.5rem",
              display: isMobile ? "none" : "inline",
              color: isDarkTheme ? "white" : "#333",
            }}
          >
            |
          </span>
          <span
            className="detail-label"
            style={{
              color: isDarkTheme ? "#B8B8D9" : "#5D5FEF", // Darker for light mode
              fontSize: "0.875rem", // Reduced from 1rem
            }}
          >
            Recorded:
          </span>
          <span
            className="detail-value"
            style={{
              fontSize: "0.875rem", // Reduced from 1rem
              fontWeight: "500",
              color: isDarkTheme ? "white" : "#333",
            }}
          >
            2019-05-24
          </span>
        </div>
      </div>
    </div>
  );
};

export default MedicalConditionCard;
